import React, { useEffect, useState } from 'react'
import {
  IconButton,
} from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import {
} from '@material-ui/icons'
import moment from 'moment-jalaali'
import MUIDataTable from 'mui-datatables'
import { useDispatch, useSelector } from 'react-redux'
import {
  //  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles'
import { debounce, throttle } from 'lodash'
// import EditIcon from 'src/icons/EditIcon'
import { Eye } from 'react-feather'
import { getMuiTheme } from '../../utils/TableStyle'
import muiDefaultOptions from '../../constants/muiTableOptions'
import {
  // getScholarships,
  searchScholarships,
} from '../../app/slices/scholarshipSlice'

const AGE_COL_NAME = 'user.ageCategoryId'
const INVENTION_COL_NAME = 'hasInvention'
const RANK_COL_NAME = 'hasRank'
const ACHIEVEMENT_COL_NAME = 'HasAchievement'
const COACH_COL_NAME = 'HasCoach'
const STATUS_COL_NAME = 'scholarshipRequestStatus'
const POSITION_COL_NAME = 'obtainedPosition'
const CITY_COL_NAME = 'user.city.name'

// const useStyles = makeStyles(() => ({
//   root: {

//   },
//   icons: {
//     color: '#b2b6c0',
//     transition: '0.2s',
//     '&:hover': {
//       color: '#f39994',
//     },
//   },
// }))

export const Scholarships = () => {
  // const classes = useStyles()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const loggedInUser = useSelector((state) => state.user)
  const isReferee = loggedInUser?.role?.roleId === 6
  const scholarships = useSelector((state) => state.scholarship.list)
  const totalHits = useSelector((state) => state.scholarship.total)
  const ageCategories = useSelector((state) => state.common.ages)
  const scholarshipRequestStatus = useSelector(
    (state) => state.common.scholarshipRequestStatus,
  )
  const scholarshipObtainedPosition = useSelector(
    (state) => state.common.scholarshipObtainedPosition,
  )

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const [searchTerm, setSearchTerm] = useState(null)
  const [filteredAgeCategories, setFilteredAgeCategories] = useState([])
  const [hasInvention, setHasInvention] = useState(null)
  const [hasRank, setHasRank] = useState(null)
  const [hasAchievement, setHasAchievement] = useState(null)
  const [hasCoach, setHasCoach] = useState(null)
  const [filteredStatus, setFilteredStatus] = useState(null)
  const [filteredPositions, setFilteredPositions] = useState(null)
  const [filteredCities, setFilteredCities] = useState([])

  const updateSearchTerm = debounce((term) => {
    setSearchTerm(term)
  }, 500, { maxWait: 1000 })

  const updateFilters = throttle((state) => {
    const ageColumnIdx = state.columns.findIndex(
      (col) => col.name === AGE_COL_NAME,
    )
    const inventionColumnIdx = state.columns.findIndex(
      (col) => col.name === INVENTION_COL_NAME,
    )
    const rankColumnIdx = state.columns.findIndex(
      (col) => col.name === RANK_COL_NAME,
    )
    const coachColumnIdx = state.columns.findIndex(
      (col) => col.name === COACH_COL_NAME,
    )
    const achievementColumnIdx = state.columns.findIndex(
      (col) => col.name === ACHIEVEMENT_COL_NAME,
    )

    const statusColumnIdx = state.columns.findIndex(
      (col) => col.name === STATUS_COL_NAME,
    )

    const positionColumnIdx = state.columns.findIndex(
      (col) => col.name === POSITION_COL_NAME,
    )

    const cityColumnIdx = state.columns.findIndex(
      (col) => col.name === CITY_COL_NAME,
    )

    setFilteredAgeCategories(
      state.filterList[ageColumnIdx].map(
        (catName) => ageCategories.find(
          (ageCat) => ageCat.name === catName,
        )?.ageCategoryId,
      ),
    )
    if (state.filterList[inventionColumnIdx].length) {
      setHasInvention(state.filterList[inventionColumnIdx][0] !== 'اختراع نداشته')
    } else {
      setHasInvention(null)
    }

    if (state.filterList[rankColumnIdx].length) {
      setHasRank(state.filterList[rankColumnIdx][0] !== 'رتبه نداشته')
    } else {
      setHasRank(null)
    }

    if (state.filterList[coachColumnIdx].length) {
      setHasCoach(state.filterList[coachColumnIdx][0] !== 'مربی نداشته')
    } else {
      setHasCoach(null)
    }

    if (state.filterList[achievementColumnIdx].length) {
      setHasAchievement(
        state.filterList[achievementColumnIdx][0] !== 'دستاورد نداشته',
      )
    } else {
      setHasAchievement(null)
    }

    if (state.filterList[statusColumnIdx].length) {
      setFilteredStatus(parseInt(Object.keys(scholarshipRequestStatus).find(
        (key) => scholarshipRequestStatus[key]
          === state.filterList[statusColumnIdx][0],
      ), 10))
    } else {
      setFilteredStatus(null)
    }

    if (state.filterList[positionColumnIdx].length) {
      setFilteredPositions(parseInt(Object.keys(scholarshipObtainedPosition).find(
        (key) => scholarshipObtainedPosition[key]
          === state.filterList[positionColumnIdx][0],
      ), 10))
    } else {
      setFilteredPositions(null)
    }

    if (state.filterList[cityColumnIdx].length) {
      setFilteredCities(state.filterList[cityColumnIdx].map((name) => ({ name })))
    } else {
      setFilteredCities(null)
    }
  }, 1000, { trailing: true, leading: false })

  useEffect(() => {
    // if (isReferee) {
    //   dispatch(getScholarships({
    //     after: currentPage * rowsPerPage,
    //     first: rowsPerPage,
    //   }))
    // } else {
    dispatch(searchScholarships(
      {
        after: currentPage * rowsPerPage,
        first: rowsPerPage,
        scholarshipRequestStatus: filteredStatus || undefined,
        userName: searchTerm || undefined,
        ageCategoryIds: filteredAgeCategories.length ? filteredAgeCategories : undefined,
        cities: filteredCities || undefined,
        hasInvention: hasInvention || undefined,
        hasRank: hasRank || undefined,
        hasAchievement: hasAchievement || undefined,
        hasCoach: hasCoach || undefined,
        obtainedPosition: filteredPositions || undefined,
      },
    ))
    // }
  }, [currentPage, rowsPerPage, searchTerm, filteredAgeCategories, hasInvention,
    hasRank, hasAchievement, hasCoach, filteredStatus, filteredPositions, filteredCities])

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => {
          return (
            <p>
              {rowIndex + 1}
            </p>
          )
        },
      },
    },
    {
      name: 'user.userName',
      label: 'نام کاربری',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: 'talent',
      label: 'نوع استعداد',
      options: {
        sort: false,
        filter: false,
      },
    },
    {
      name: STATUS_COL_NAME,
      label: 'وضعیت',
      options: {
        customBodyRender: (value) => (value ? scholarshipRequestStatus[value] : '-'),
        sort: false,
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: Object.values(scholarshipRequestStatus),
        },
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
      },
    },
    {
      name: AGE_COL_NAME,
      label: 'رده سنی',
      options: {
        customBodyRender: (value) => ageCategories.find((cat) => cat.ageCategoryId === value)?.name || '-',
        display: false,
        sort: false,
        filter: true,
        filterOptions: {
          names: ageCategories.map((cat) => cat.name),
        },
      },
    },
    {
      name: INVENTION_COL_NAME,
      label: 'اختراع دارد؟',
      options: {
        customBodyRender: (value) => (value ? 'بلی' : 'خیر'),
        display: false,
        sort: false,
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: ['اختراع داشته', 'اختراع نداشته'],
        },
      },
    },
    {
      name: RANK_COL_NAME,
      label: 'رتبه دارد؟',
      options: {
        customBodyRender: (value) => (value ? 'بلی' : 'خیر'),
        display: false,
        sort: false,
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: ['رتبه داشته', 'رتبه نداشته'],
        },
      },
    },
    {
      name: POSITION_COL_NAME,
      label: 'کسب مقام',
      options: {
        customBodyRender: (value) => (value ? scholarshipObtainedPosition[value] : '-'),
        display: false,
        sort: false,
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: Object.values(scholarshipObtainedPosition),
        },
      },
    },
    {
      name: ACHIEVEMENT_COL_NAME,
      label: 'دستاورد دارد؟',
      options: {
        customBodyRender: (value) => (value ? 'بلی' : 'خیر'),
        display: false,
        sort: false,
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: ['دستاورد داشته', 'دستاورد نداشته'],
        },
      },
    },
    {
      name: COACH_COL_NAME,
      label: 'مربی داشته؟',
      options: {
        customBodyRender: (value) => (value ? 'بلی' : 'خیر'),
        display: false,
        sort: false,
        filter: true,
        filterType: 'dropdown',
        filterOptions: {
          names: ['مربی نداشته', 'مربی داشته'],
        },
      },
    },
    {
      name: CITY_COL_NAME,
      label: 'شهر',
      options: {
        display: false,
        sort: false,
        filter: true,
        filterType: 'textField',

      },
    },
    {
      name: 'scholarshipRequestId',
      label: 'مدیریت',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => {
          return (
            <>
              <Link to={pathname === '/app' ? `./scholarships/review/${value}` : `./review/${value}`}>
                <IconButton>
                  {/* <EditIcon className={classes.icons} /> */}
                  <Eye />
                </IconButton>
              </Link>
            </>
          )
        },
      },
    },
  ]
  return (
  // <Card className={classes.root}>
  //   <CardContent>
    <ThemeProvider theme={getMuiTheme}>
      <MUIDataTable
        data={scholarships}
        columns={COLUMNS}
        options={{
          ...muiDefaultOptions,
          enableNestedDataAccess: '.',
          filter: !isReferee,
          filterType: 'multiselect',
          search: !isReferee,
          serverSide: true,
          count: totalHits,
          page: currentPage,
          rowsPerPage,
          onTableChange: (action, state) => {
            switch (action) {
              case 'changeRowsPerPage':
                setRowsPerPage(state.rowsPerPage)
                break
              case 'filterChange':
                updateFilters(state)
                break
              case 'changePage':
                setCurrentPage(state.page)
                break
              case 'search':
                updateSearchTerm(state.searchText)
                break
              default:
                break
            }
          },
          rowHover: true,
          selectableRows: 'none',
        }}
      />
    </ThemeProvider>
  //   </CardContent>
  // </Card>
  )
}

export default Scholarships
